export default "__VITE_ASSET__To_Y8t3A__"